/**
 * @license
 * Copyright 2025 Google Inc.
 * SPDX-License-Identifier: Apache-2.0
 */

// If moved update release-please config
// x-release-please-start-version
export const packageVersion = '24.35.0';
// x-release-please-end
